import { Box, Link, Tooltip } from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import BasicModal from 'components/BasicModal';
import { vendorInvoiceStyles } from '../style';
import UnsupportedFilePreview from './UnsupportedFilePreview';

const VendorInvoicePreview = ({ invoice, onClose }) => {
    const classes = vendorInvoiceStyles();

    if (!invoice) return null;

    const getFileExtension = (fileName) => {
        return fileName?.split('.').pop()?.toLowerCase();
    };

    const unsupportedExtensions = ['pdf', 'jpeg', 'jpg', 'png', 'gif', 'bmp', 'tiff', 'tif', 'webp', 'svg'];

    const isSupported = unsupportedExtensions.includes(getFileExtension(invoice.fileUrl));

    return (
        <BasicModal
            open={!!invoice}
            wide={true}
            handleClose={onClose}
            component={
                <Box className={classes.embedContainer}>
                    {isSupported ? (
                        <embed
                            src={invoice.fileUrl}
                            type={invoice.fileType}
                            className={classes.embed}
                        />
                    ) : (
                        <UnsupportedFilePreview
                            fileUrl={invoice.fileUrl}
                            fileName={invoice.fileName}
                            classes={classes}
                        />
                    )}
                    <div item className={classes.linkContent}>
                        <Link
                            className={classes.openInNewTab}
                            href={invoice?.fileUrl} target="_blank" color="primary" >
                            <Tooltip title='Open in new tab'><OpenInNewIcon /></Tooltip>
                        </Link>
                    </div>
                </Box>
            }
        />
    );
};

export default VendorInvoicePreview;
